import axios from 'axios';

export interface ReportingTarget {
  priority: string;
  dispatch_duration_minutes: number;
  template_ids?: number[];
}

export interface DispatchSettingsResponse {
  dispatch_runtime_minutes?: number;
  revert_to_draft_on_no_available?: boolean;
  reporting_targets?: ReportingTarget[];
}

export interface SmartDispatchRequest {
  workOrders: Array<{
    id: number;
    settings: Record<string, unknown>;
  }>;
}

export interface DispatchExpansionSettingsResponse {
  _included?: {
    expansionSettings?: {
      marketplace?: { enabled: boolean };
      serviceTerritory?: { enabled: boolean };
      talentPools?: { enabled: boolean };
    };
  };
}

async function makeApiRequest<T>(
  url: string,
  options: Record<string, unknown> = {},
): Promise<T> {
  try {
    const response = await axios({
      url,
      timeout: 10000,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      ...options,
    });

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Fetches dispatch settings for a specific project
 */
export const getDispatchSettings = async (
  projectId: string | number,
): Promise<DispatchSettingsResponse> => makeApiRequest<DispatchSettingsResponse>(
  `/dispatch-automation/v1/projects/${projectId}/dispatch-settings?includes=reporting_targets`,
  { method: 'GET' },
);

/**
 * Fetches V2 dispatch expansion settings (service territory, marketplace, talent pools)
 * to determine which provider segments are enabled for a project.
 */
export const getDispatchExpansionSettings = async (
  projectId: string | number,
): Promise<DispatchExpansionSettingsResponse> => makeApiRequest<DispatchExpansionSettingsResponse>(
  `/dispatch-automation/v2/projects/${projectId}/dispatch-settings?returnLatestRow=1&include=expansionSettings`,
  { method: 'GET' },
);
